import { get, post } from 'api';
import config from 'config';

const dealerUrl = config.get('api.dealer');

const authenticateUser = async (dealerId: string, userName: string, password: string, token: string): Promise<any> => {
  const requestBody: any = {
    dealerId,
    userName,
    password,
    token,
  };

  const { data } = await post(`${config.get('api.authentication')}/v2/authentication`, requestBody);
  return data;
};

const refreshTokenUser = async (refreshToken: string): Promise<any> => {
  const { data } = await post(`${config.get('api.authentication')}/refreshToken`, { refreshToken });
  return data;
};

const validateTokenUser = async (): Promise<any> => {
  const { data } = await get(`${dealerUrl}/validateToken`);
  return data;
};

const getPreLoginToken = async (): Promise<any> => {
  const { data } = await get(`${config.get('api.authentication')}/preLoginToken`);
  return data;
};

export default { authenticateUser, refreshTokenUser, validateTokenUser, getPreLoginToken };
